import React, { useState } from "react";
import { MDBBtn, MDBCheckbox } from "mdb-react-ui-kit";
import "./ImageProcessingStep.css";

const ImageProcessingStep = ({
  formData,
  processing,
  processingImages,
  progress,
  processedImages,
  handleSwapImages,
  handleInputChange,
  handleStartImageEditing,
  rotateProcessedImageRight,  // ← CHANGE: processed image rotate
  rotateProcessedImageLeft,   // ← CHANGE: processed image rotate
}) => {
  const [selected, setSelected] = useState([]);

  const handleSelect = (index) => {
    let newSelected = [...selected];
    if (newSelected.includes(index)) {
      newSelected = newSelected.filter((i) => i !== index);
    } else {
      if (newSelected.length === 2) newSelected.shift();
      newSelected.push(index);
    }
    setSelected(newSelected);
  };

  const handleSwap = () => {
    if (selected.length !== 2) return;
    const [first, second] = selected;
    handleSwapImages(first, second);
    setSelected([]);
  };

  return (
    <div className="step-panel">
      <div className="step-header">
        <h2>Image Processing</h2>
        <p>Select enhancements to apply to your images</p>
      </div>

      <div className="image-options">
        <MDBCheckbox
          label="Background Removal"
          checked={formData.backgroundRemoval}
          onChange={(e) =>
            handleInputChange("backgroundRemoval", e.target.checked)
          }
        />

        <MDBCheckbox
          label="Upscale Image"
          checked={formData.upscaleImage}
          onChange={(e) => handleInputChange("upscaleImage", e.target.checked)}
        />
      </div>

      <MDBBtn
        className="mt-3"
        disabled={processing}
        onClick={handleStartImageEditing}
      >
        {processing ? "Processing..." : "Start Image Processing"}
      </MDBBtn>

      {processingImages && (
        <div className="progress-bar-wrapper mt-3">
          <div className="progress-bar-bg">
            <div
              className="progress-bar-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span>{progress}% Processing</span>
        </div>
      )}

      {processedImages.length > 0 && (
        <>
          <h4 className="mt-4">Processed Images (Click to select for swap)</h4>
          <div className="image-grid mt-2">
            {processedImages.map((img, index) => (
              <div
                key={index}
                className={`image-item ${
                  selected.includes(index) ? "selected" : ""
                }`}
                onClick={() => handleSelect(index)}
              >
                <img
                  src={img}
                  alt={`Processed ${index + 1}`}
                  className="image-thumb"
                />

                {/* Rotate buttons for processed images */}
                <div className="rotate-buttons">
                  <button
                    className="rotate-btn-left"
                    onClick={(e) => {
                      e.stopPropagation();
                      rotateProcessedImageLeft(index);
                    }}
                    title="Rotate Left"
                  >
                    ↺
                  </button>
                  <button
                    className="rotate-btn-right"
                    onClick={(e) => {
                      e.stopPropagation();
                      rotateProcessedImageRight(index);
                    }}
                    title="Rotate Right"
                  >
                    ↻
                  </button>
                </div>
                
                <div className="image-index">{index + 1}</div>
              </div>
            ))}
          </div>

          {selected.length === 2 && (
            <MDBBtn className="mt-3" onClick={handleSwap}>
              Swap Selected Images
            </MDBBtn>
          )}
        </>
      )}

      <style>{`
        .image-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
          gap: 1rem;
          margin-top: 1rem;
        }
        
        .image-item {
          position: relative;
          background: #f8f9fa;
          border-radius: 8px;
          padding: 0.5rem;
          border: 2px solid transparent;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .image-item.selected {
          border-color: #dc3545;
          box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
        }
        
        .image-thumb {
          width: 100%;
          height: 150px;
          object-fit: cover;
          border-radius: 4px;
        }
        
        .image-index {
          position: absolute;
          top: 8px;
          left: 8px;
          background: rgba(0,0,0,0.6);
          color: white;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: bold;
          z-index: 2;
        }
        
        .rotate-buttons {
          position: absolute;
          bottom: 12px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          gap: 8px;
          opacity: 0;
          transition: opacity 0.2s ease;
          z-index: 2;
        }
        
        .image-item:hover .rotate-buttons {
          opacity: 1;
        }
        
        .rotate-btn-left,
        .rotate-btn-right {
          background: rgba(0, 0, 0, 0.75);
          border: none;
          color: white;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }
        
        .rotate-btn-left:hover,
        .rotate-btn-right:hover {
          background: #dc3545;
          transform: scale(1.1);
        }
        
        .progress-bar-wrapper {
          background: #e0e0e0;
          border-radius: 4px;
          overflow: hidden;
          height: 30px;
          position: relative;
        }
        
        .progress-bar-bg {
          width: 100%;
          height: 100%;
          background: #f0f0f0;
        }
        
        .progress-bar-fill {
          background: #dc3545;
          height: 100%;
          transition: width 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 12px;
        }
      `}</style>
    </div>
  );
};

export default ImageProcessingStep;